export default __webpack_public_path__ + "static/media/kitchen.e5e532eb.png";